import { render, staticRenderFns } from "./descriptionOfPack.vue?vue&type=template&id=e260b364&"
import script from "./descriptionOfPack.vue?vue&type=script&lang=js&"
export * from "./descriptionOfPack.vue?vue&type=script&lang=js&"
import style0 from "./descriptionOfPack.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports